<template>
<div class="page">
  <Header title="帮助中心" />

  <div class="center-info">
    <div class="center-info-item center-item-box" v-if="rule==='OES'||rule==='IAM'">
      <van-cell is-link to="/privacy">
        <template #title>
          <span class="custom-title">隐私条款</span>
        </template>
      </van-cell>
      <van-cell is-link to="/solution1?id=1">
        <template #title>
          <span class="custom-title">忘记用户名、密码</span>
        </template>
      </van-cell>
      <van-cell is-link to="/solution1?id=2">
        <template #title>
          <span class="custom-title">修改密码</span>
        </template>
      </van-cell>
      <van-cell is-link to="/solution1?id=3">
        <template #title>
          <span class="custom-title">修改信息</span>
        </template>
      </van-cell>
      <van-cell is-link to="/solution1?id=4">
        <template #title>
          <span class="custom-title">积分获取途径</span>
        </template>
      </van-cell>
      <van-cell is-link to="/solution1?id=5">
        <template #title>
          <span class="custom-title">秒杀/抢购失效</span>
        </template>
      </van-cell>
      <van-cell is-link to="/solution1?id=6">
        <template #title>
          <span class="custom-title">积分/消费异常</span>
        </template>
      </van-cell>
      <van-cell is-link to="/solution1?id=7">
        <template #title>
          <span class="custom-title">信息泄露</span>
        </template>
      </van-cell>
      <van-cell is-link to="/solution1?id=8">
        <template #title>
          <span class="custom-title">促销活动查询</span>
        </template>
      </van-cell>

      <van-cell is-link to="/solution1?id=9">
        <template #title>
          <span class="custom-title">取消订单</span>
        </template>
      </van-cell>
      <van-cell is-link to="/solution1?id=10">
        <template #title>
          <span class="custom-title">修改订单</span>
        </template>
      </van-cell>
      <van-cell is-link to="/solution1?id=11">
        <template #title>
          <span class="custom-title">礼品到货时间</span>
        </template>
      </van-cell>
      <van-cell is-link to="/solution1?id=12">
        <template #title>
          <span class="custom-title">物流状态查询</span>
        </template>
      </van-cell>
      <van-cell is-link to="/solution1?id=13">
        <template #title>
          <span class="custom-title">订单拆分</span>
        </template>
      </van-cell>
      <van-cell is-link to="/solution1?id=14">
        <template #title>
          <span class="custom-title">订单状态查询</span>
        </template>
      </van-cell>
      <van-cell is-link to="/solution1?id=15">
        <template #title>
          <span class="custom-title">订单异常</span>
        </template>
      </van-cell>
      <van-cell is-link to="/solution1?id=16">
        <template #title>
          <span class="custom-title">拒收订单</span>
        </template>
      </van-cell>
      <van-cell is-link to="/solution1?id=17">
        <template #title>
          <span class="custom-title">申请退换货</span>
        </template>
      </van-cell>
      <van-cell is-link to="/solution1?id=18">
        <template #title>
          <span class="custom-title">操作须知</span>
        </template>
      </van-cell>
    </div>

    <div class="center-info-item center-item-box" v-if="rule==='SAH'">
      <van-cell is-link to="/privacy">
        <template #title>
          <span class="custom-title">隐私条款</span>
        </template>
      </van-cell>
      <van-cell is-link to="/solution?id=1">
        <template #title>
          <span class="custom-title">忘记用户名、密码</span>
        </template>
      </van-cell>
      <van-cell is-link to="/solution?id=2">
        <template #title>
          <span class="custom-title">修改密码</span>
        </template>
      </van-cell>
      <van-cell is-link to="/solution?id=3">
        <template #title>
          <span class="custom-title">修改信息</span>
        </template>
      </van-cell>
      <van-cell is-link to="/solution?id=4">
        <template #title>
          <span class="custom-title">积分获取途径</span>
        </template>
      </van-cell>
      <van-cell is-link to="/solution?id=5">
        <template #title>
          <span class="custom-title">秒杀/抢购失效</span>
        </template>
      </van-cell>
      <van-cell is-link to="/solution?id=6">
        <template #title>
          <span class="custom-title">积分/消费异常</span>
        </template>
      </van-cell>
      <van-cell is-link to="/solution?id=7">
        <template #title>
          <span class="custom-title">信息泄露</span>
        </template>
      </van-cell>
      <van-cell is-link to="/solution?id=8">
        <template #title>
          <span class="custom-title">促销活动查询</span>
        </template>
      </van-cell>
      <van-cell is-link to="/solution?id=9">
        <template #title>
          <span class="custom-title">取消订单</span>
        </template>
      </van-cell>
      <van-cell is-link to="/solution?id=10">
        <template #title>
          <span class="custom-title">修改订单</span>
        </template>
      </van-cell>
      <van-cell is-link to="/solution?id=11">
        <template #title>
          <span class="custom-title">礼品到货时间</span>
        </template>
      </van-cell>
      <van-cell is-link to="/solution?id=12">
        <template #title>
          <span class="custom-title">物流状态查询</span>
        </template>
      </van-cell>
      <van-cell is-link to="/solution?id=13">
        <template #title>
          <span class="custom-title">订单拆分</span>
        </template>
      </van-cell>
      <van-cell is-link to="/solution?id=14">
        <template #title>
          <span class="custom-title">订单状态查询</span>
        </template>
      </van-cell>
      <van-cell is-link to="/solution?id=15">
        <template #title>
          <span class="custom-title">订单异常</span>
        </template>
      </van-cell>
      <van-cell is-link to="/solution?id=16">
        <template #title>
          <span class="custom-title">拒收订单</span>
        </template>
      </van-cell>
      <van-cell is-link to="/solution?id=17">
        <template #title>
          <span class="custom-title">申请退换货</span>
        </template>
      </van-cell>
      <van-cell is-link to="/solution?id=18">
        <template #title>
          <span class="custom-title">操作须知</span>
        </template>
      </van-cell>
    </div>

    <div class="block"></div>
  </div>
</div>
</template>

<script>
import Header from '@/components/header'
import centerApi from '@/api/center'
export default {
  components: {
    Header
  },
  data () {
    return {
      rule: ''
    }
  },
  created () {
    this.getClientInfo()
  },
  methods: {
    getClientInfo () {
      centerApi.getClientInfo().then(res => {
        if (res.data.resultCode === '0') {
          this.rule = res.data.resultData.clientInfo.marketName
        }
      })
    }
  }
}
</script>

<style scoped lang="less">

/* 头像 */
.center-head-portrait{
    position: relative;
    width: 100%;
    height: 100px;
    display: flex;
    vertical-align: middle;
    img{
      padding: 20px 0 0 10px;
      width: 80px;
      height: 80px;
      border-radius: 50%;
    }
    .center-user-info{
      margin: 30px 0 0 10px;
    }
    .center-user-info-name{
      font-size: 18px;
      line-height: 32px;
    }
    .center-user-info-mobile{
      color: rgb(175, 175, 175);
    }
}
.center-head-portrait .center-head-portrait-bg{
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 9;
}
.center-head-portrait .center-head-portrait-wrapper{
    position: absolute;
    top: 50%;
    left: 50%;
    width: 3.25rem;
    height: 3.25rem;
    -webkit-transform: translate(-50%,-50%);
            transform: translate(-50%,-50%);
    z-index: 10;
}
.center-head-portrait .center-head-portrait-icon{
    position: absolute;
    top: 50%;
    left: 50%;
    width: 1.95rem;
    height: 1.95rem;
    -webkit-transform: translate(-50%,-50%);
            transform: translate(-50%,-50%);
    z-index: 10;
}

/* 卡券积分 */
.center-info{
  margin: 0 10px;
  width: calc(100% - 20px);
}
.center-info-item{
  margin-top: 15px;
  padding-top: 0.1rem;
  padding-bottom: 0.06rem;
  background-color: #fff;
  // display: flex;
  // justify-content: space-evenly;
  // height: 60px;
  // line-height: 20px;
  // align-items: center;
  // text-align: center;
  //border-bottom: 5px solid #65bac7;
  border-radius: 5px;
}
.center-integration-coupon{
    padding-top: 0.1rem;
    padding-bottom: 0.06rem;
    background-color: #fff;
    display: flex;
    justify-content: space-evenly;
    height: 60px;
    line-height: 20px;
    align-items: center;
    text-align: center;
    border-bottom: 5px solid #65bac7;
}
.center-integration-coupon-item{
  flex:1;
}
.center-integration-border{
  border-right: 1px solid #f1f1f1;
}
.center-integration-coupon-title{
    font-size:14px;
    color: #117281;
}
.center-integration-coupon-num{
    color: #e41b2c;
    font-size: 0.24rem;
}
.center-item-box{
  align-items: center;
  vertical-align: middle;
  img{
    position: absolute;
    top: 12px;
    width: 18px;
    margin-right: 10px;
  }
  .custom-title{
    padding-left: 10px;
  }
}

.logout-btn{
  text-align: center;
  line-height: 40px;
}
.block{
  width: 100%;
  height: 56px;
}
</style>
